import {
  anOutlierRule,
  anUpdateOutlierRule,
  mockUpdateOutlierRuleBuilderOperationMutation,
  UpdateOutlierRuleBuilderOperationMutation,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

import { OUTLIER_RULE_DATA_UPDATED } from '../queries/RuleBuilderQueryOperation.mocks';

export const updateOutlierRuleResponse: UpdateOutlierRuleBuilderOperationMutation =
  {
    __typename: 'Mutation',
    updateOutlierRule: anUpdateOutlierRule({
      data: anOutlierRule({
        ...OUTLIER_RULE_DATA_UPDATED,
      }),
    }),
  };

export const handlers = [
  mockUpdateOutlierRuleBuilderOperationMutation(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: updateOutlierRuleResponse,
      });
    }
  ),
];
